import type { ElowenUiRuntime } from 'elowen-plugin-ui-kit';
import { getConnectionPolicy, loadConnectionPolicy } from './elowenClient';
import { ProjectUploadRefusal, uploadProjectFileProtocol } from './projectUploadProtocol';

type UploadClient = ElowenUiRuntime['utils']['uploadProjectFile'];

/** Browser adapter: same-origin account authentication and the existing attachment notices. */
export const uploadProjectFile: UploadClient = async (file, target, opts = {}) => {
  try {
    return await uploadProjectFileProtocol(file, target, {
      request: (path, init) => fetch(`/api${path}`, init),
      loadPolicy: loadConnectionPolicy,
      getPolicy: getConnectionPolicy,
    }, opts);
  } catch (error) {
    if (opts.signal?.aborted) return { failed: true, cancelled: true };
    const failure = error instanceof AggregateError ? error.cause : error;
    return failure instanceof ProjectUploadRefusal ? { failed: true, reason: failure.reason } : { failed: true };
  }
};
